/* Triple Y: חצי הגלילה של רצועת דגמי אייפון 18. נבנה 10.09.2026.
 *
 * 🔴 האצלה מ-document ולא מאזין על האלמנט. סקשן בדף הבית אמנם אינו
 *    מרונדר מחדש כמו רשת המוצרים, אבל עורך התמה כן מחליף את ה-HTML
 *    שלו בכל שינוי הגדרה, ואז מאזין שנרשם על כפתור מת יחד איתו.
 *
 * 🔴 הכיוון נגזר מ-direction המחושב. בחנות RTL "הבא" הוא שמאלה, ולכן
 *    ערך left חיובי היה גולל אחורה. לא מניחים RTL, מודדים.
 *
 * 📌 החצים מרונדרים בליקוויד רק בפריסה שבה השרת יודע שהרצועה גולשת.
 *    הקובץ הזה אינו מחליט אם להציג אותם, ולכן אין כאן הבהוב.
 */
(function () {
  'use strict';
  if (window.__tyI18Rail) return;
  window.__tyI18Rail = true;

  function trackOf(btn) {
    var root = btn.closest('[data-ty-i18r]');
    return root ? root.querySelector('[data-tyir-track]') : null;
  }

  /** רוחב קפיצה: כרטיס אחד ועוד המרווח שבינו לבין הבא. */
  function step(track) {
    var card = track.querySelector('[data-tyir-card]');
    if (!card) return Math.round(track.clientWidth * 0.8);
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function sync(root) {
    var track = root.querySelector('[data-tyir-track]');
    var prev = root.querySelector('[data-tyir-prev]');
    var next = root.querySelector('[data-tyir-next]');
    if (!track || !prev || !next) return;

    /* בכרום RTL ‏scrollLeft הוא 0 בהתחלה ושלילי בהמשך. מודדים במרחק
       מוחלט מהקצה, וכך אותו קוד נכון בשני הכיוונים. */
    var max = track.scrollWidth - track.clientWidth;
    var at = Math.abs(track.scrollLeft);
    prev.disabled = at <= 1;
    next.disabled = at >= max - 1;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tyir-prev],[data-tyir-next]');
    if (!btn) return;
    var track = trackOf(btn);
    if (!track) return;

    var rtl = getComputedStyle(track).direction === 'rtl';
    var forward = btn.hasAttribute('data-tyir-next');
    var dir = forward ? 1 : -1;
    if (rtl) dir = -dir;

    track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target;
      if (!track || !track.hasAttribute || !track.hasAttribute('data-tyir-track')) return;
      var root = track.closest('[data-ty-i18r]');
      if (root) sync(root);
    },
    true
  );

  function boot() {
    document.querySelectorAll('[data-ty-i18r]').forEach(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('resize', boot);
})();
